import { useEffect, RefObject } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

interface UseNextStepAnimationParams {
  sectionRef: RefObject<HTMLDivElement | null>;
  targetRef: RefObject<HTMLDivElement | null>;
}

export const useNextStepAnimation = ({
  sectionRef,
  targetRef,
}: UseNextStepAnimationParams): void => {
  useEffect(() => {
    const scrollContainer = sectionRef.current;
    const targetContainer = targetRef.current;
    if (!scrollContainer || !targetContainer) return;

    gsap.registerPlugin(ScrollTrigger);

    const yOffset = "-18%";

    // Create scroll timeline with two phases:
    // Phase 1: Scroll up to -titleHeight - animation completes
    // Phase 2: Hold at -titleHeight - hold before natural scroll continues
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: scrollContainer,
        start: "top top",
        end: "30% top",
        scrub: 1,
      },
    });

    // Phase 1: Scroll up to -titleHeight (0-60% of timeline)
    tl.to(targetContainer, {
      y: yOffset,
      duration: 0.3,
      ease: "power2.out",
    });

    // // Phase 2: Hold at -titleHeight (60-100% of timeline)
    // tl.fromTo(
    //   targetContainer,
    //   { y: yOffset },
    //   {
    //     y: yOffset,
    //     duration: 0.4,
    //     ease: "none",
    //     immediateRender: false,
    //   }
    // );

    return () => {
      tl.kill();
    };
  }, [sectionRef, targetRef]);
};
